import React from 'react';
import Header from "../../common/Header/Header";
import LoginForm from "./LoginForm";
import {NavLink} from "react-router-dom";
import s from './login.module.sass'


const Login = () => {
    return (
        <main className="wrap">
            <Header/>
            <div className={s.loginWrap}>
                <h1 className="h1">Login</h1>
                <LoginForm/>
                <span className={s.signup}>
                    <nav>
                        <li><NavLink to='/signup'>Sign Up</NavLink></li>
                        <li><NavLink to='/forgot'>Forgot password</NavLink></li>
                    </nav>
                </span>
            </div>
        </main>

    );
};

export default Login;